import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/(redirects)/payment-method-update')({
  component: () => <Navigate replace to="/unpaid-invoices" />,
})
